export default __webpack_public_path__ + "media/storefront/features/hymns/hymns/Panama-a6615dc62d7d2f67dee95f1454352dd8.mp3";